import { TblPanierReglementJsonldPanierunitaireRead } from '@europrocurement/l2d-domain/openApi/ApiFacturation';

import { Divider, Typography } from '@mui/material';
import React from 'react';

export type PanierReglementTitleProps = {
    panier: TblPanierReglementJsonldPanierunitaireRead;
    selectionnables: boolean;
};

const PanierReglementTitle: React.FunctionComponent<PanierReglementTitleProps> = function (props) {
    const { panier, selectionnables } = props;

    let element = 'élément';
    if (
        (panier?.dossiers === undefined || panier?.dossiers.length === 0) &&
        (panier?.factures === undefined || panier?.factures.length === 0) &&
        panier?.collections !== undefined &&
        panier?.collections.length > 0
    ) {
        element = 'commande';
    }
    if (
        (panier?.dossiers === undefined || panier?.dossiers.length === 0) &&
        (panier?.collections === undefined || panier?.collections.length === 0) &&
        panier?.factures !== undefined &&
        panier?.factures.length > 0
    ) {
        element = 'facture';
    }
    if (
        (panier?.collections === undefined || panier?.collections.length === 0) &&
        (panier?.factures === undefined || panier?.factures.length === 0) &&
        panier?.dossiers !== undefined &&
        panier?.dossiers.length > 0
    ) {
        element = 'dossier';
    }
    return (
        <>
            <Typography variant="l2dh6">
                {`${element.charAt(0).toUpperCase() + element.slice(1)}s disponibles`}
            </Typography>
            <Typography
                variant="l2dlabel"
                sx={{ color: 'text.gris70' }}
            >
                {selectionnables
                    ? `Sélectionnez les ${element}s à payer`
                    : `${element.charAt(0).toUpperCase() + element.slice(1)} à payer`}
            </Typography>
            <Divider />
        </>
    );
};

export default PanierReglementTitle;
